// extracted by mini-css-extract-plugin
module.exports = {"lastTradedContainer":"LastTradedValues_lastTradedContainer__2Fxnk"};